import React, { useEffect, useState } from 'react';
import Empty from '../feedback/Empty';
import moment from 'moment';
import { GrAdd } from 'react-icons/gr';
import adminServices from '../../services/AdminServices';
import Loading from '../feedback/Loading';
import ServiceModal from './ServiceModal';
import utils from '../../utils';

function DashboardServices() {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState(0);
    const [activeService, setActiveService] = useState(null);

    useEffect(() => {
        fetchServices();
    }, []);

    useEffect(() => { }, [services])

    const fetchServices = () => {
        setLoading(true);
        adminServices.getServices()
            .then(res => {
                setServices(res.data || []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Failed to fetch services:', err);
                setLoading(false);
            });
    };

    const openModal = (actionType, service = null) => {
        const openBtn = document.getElementById('service-open-btn');
        if (openBtn) {
            setAction(actionType);
            setActiveService(service);
            openBtn.click();
        }
    };

    return (
        <div className='space-y-5'>
            {/* Header */}
            <div className="flex md:items-end justify-between gap-4 items-center">
                <h3 className='text-xl font-bold'>
                    Services{' '}
                    <span className='ml-2 text-gray-500'>
                        ({services.length})
                    </span>
                </h3>
                <button
                    onClick={() => openModal(0)}
                    className="inline-flex items-center justify-center px-4 py-2 bg-primary hover:bg-sky-600 border border-transparent rounded-lg text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary shadow-sm transition-all"
                >
                    <GrAdd className='h-5 w-5 mr-2' />
                    Add New Service
                </button>
            </div>
            <ServiceModal
                action={action}
                activeService={activeService}
                onReload={fetchServices}
                setActiveService={setActiveService}
            />
            <div>
                <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark overflow-hidden">
                    <div className='overflow-x-auto'>
                        <table className="table table-compact table-zebra w-full">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Service</th>
                                    <th>Cost</th>
                                    <th className='hidden md:table-cell'>Nurses</th>
                                    <th className='hidden md:table-cell'>Patients</th>
                                    <th className='hidden md:table-cell'>Created</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {services?.length ? (
                                    <>
                                        {services?.map((service, idx) => (
                                            <tr key={service.id || idx}>
                                                <td className='font-bold'>{service?.name}</td>
                                                <td>{service?.category?.name || '—'}</td>
                                                <td className='font-bold'>{utils.toCommas(service?.price || 0)}</td>
                                                <td className='hidden md:table-cell'>{service?.nurse_count || 0}</td>
                                                <td className='hidden md:table-cell'>{service?.patient_count || 0}</td>
                                                <td className='hidden md:table-cell font-bold'>
                                                    {moment(service.created_at).format('MMM Do YYYY')}
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => openModal(1, service)}
                                                        className='btn btn-sm btn-secondary'
                                                    >
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </>
                                ) : null}

                            </tbody>
                        </table>
                        {loading && (<Loading />)}
                        {!services?.length && (
                            <div className="p-3">
                                <Empty objectName="Medical Services" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DashboardServices;